import { Button, Stack, type Theme, Typography } from '@mui/material';
import ModalV2 from '/@/components/bayer/modal-v2';
import type { RVAdvisorInvitationApi } from '/@/hooks/nodes/index.tsx';
import { _ } from '/@/locale';
import { modalBodyPropsWide, modalProps } from '../index.tsx';
import { useInvitationStatus } from './sended-invitations.tsx';

const RVOnboardingModalSentInvites = ({
    open,
    onClose,
    invitation,
    onResendInvitation,
    onVinculateWithOtherRv,
}: {
    open: boolean;
    onClose: () => void;
    invitation?: RVAdvisorInvitationApi;
    onResendInvitation: () => void;
    onVinculateWithOtherRv: () => void;
}) => {
    const invitationStatus = useInvitationStatus();
    return (
        <ModalV2
            open={open}
            onClose={onClose}
            {...modalProps}
            maxWidth='sm'
            bodyProps={{
                ...modalProps.bodyProps,
                ...modalBodyPropsWide,
                sx: {
                    p: 0,
                    width: '100%',
                },
                spacing: 0,
            }}
            title={_('Solicitud de vinculación')}
            actions={
                invitation?.status === 'declined' && (
                    <Stack direction='row' spacing={2} justifyContent='space-between' sx={{ width: '100%' }}>
                        <Button variant='text' color='secondary' onClick={onVinculateWithOtherRv}>
                            {_('Vincularme con otro RV')}
                        </Button>
                        <Button variant='contained' color='secondary' onClick={onResendInvitation}>
                            {_('Reenviar solicitud al mismo RV')}
                        </Button>
                    </Stack>
                )
            }
        >
            <Stack spacing={3} sx={{ p: 5, width: '100%' }}>
                <Typography variant='body1' color='primary'>
                    {invitationStatus[invitation?.status as keyof typeof invitationStatus]?.descriptionText ?? ''}
                </Typography>
                <Stack
                    p={2}
                    direction='row'
                    justifyContent='space-between'
                    alignItems='center'
                    sx={{
                        border: (t: Theme) => `1px solid ${t.palette.divider}`,
                    }}
                >
                    <Stack direction='column' justifyContent='flex-start' alignItems='flex-start'>
                        <Typography variant='body1' color='primary' fontWeight='bold'>
                            {invitation?.rv?.name}
                        </Typography>
                        <Typography variant='body1' color='primary'>
                            {_('RV Premium')}
                        </Typography>
                    </Stack>
                    <Stack direction='row' alignItems='center' spacing={1}>
                        <Stack direction='row' alignItems='center' spacing={1}>
                            {invitationStatus[invitation?.status as keyof typeof invitationStatus]?.icon}
                            <Stack direction='column' justifyContent='flex-start' alignItems='flex-start'>
                                <Typography variant='body1' color='primary'>
                                    {invitationStatus[invitation?.status as keyof typeof invitationStatus]?.label}
                                </Typography>
                            </Stack>
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>
        </ModalV2>
    );
};

export default RVOnboardingModalSentInvites;
